import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaStar } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
    const [testimonials, setTestimonials] = useState([]);

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const fetchTestimonials = async () => {
        try {
            const response = await axios.get('http://localhost:5000/api/testimonials');
            setTestimonials(response.data);
        } catch (error) {
            console.error('Error fetching testimonials:', error);
        }
    };

    const sampleTestimonials = [
        {
            id: 1,
            customer_name: 'Suresh Verma',
            location: 'Mumbai to Pune',
            rating: 5,
            review_text: 'Bk Packers and Movers made my house shifting completely hassle-free. The team was punctual, professional, and packed all items with great care. Highly recommended for safe relocation.'
        },
        {
            id: 2,
            customer_name: 'Neha Kulkarni',
            location: 'Office Relocation - Bangalore',
            rating: 5,
            review_text: 'Our office relocation was handled smoothly by Bk Packers and Movers. Their planning and coordination ensured zero downtime and safe movement of all office equipment.'
        },
        {
            id: 3,
            customer_name: 'Rohit Mehta',
            location: 'Ahmedabad to Hyderabad',
            rating: 5,
            review_text: 'Affordable pricing with excellent service quality. Bk Packers and Movers ensured timely delivery and safe handling of all my household items. Will surely use their service again.'
        },
        {
            id: 4,
            customer_name: 'Amit Sharma',
            location: 'Delhi to Mumbai',
            rating: 5,
            review_text: 'Bk Packers and Movers provided excellent household shifting services. Their professional packing, careful loading, and timely delivery made my relocation stress-free and smooth.'
        },
        {
            id: 5,
            customer_name: 'Pooja Nair',
            location: 'Chennai to Kochi',
            rating: 5,
            review_text: 'Best packers and movers service I have experienced. BK Packers and Movers handled fragile items with care and ensured safe relocation at a very reasonable price.'
        },
        {
            id: 6,
            customer_name: 'Kunal Patel',
            location: 'Surat to Jaipur',
            rating: 5,
            review_text: 'Bk Packers and Movers are reliable and trustworthy movers. From packing to final delivery, everything was managed professionally, making my interstate relocation easy.'
        }
    ];

    const displayTestimonials = testimonials.length > 0 ? testimonials : sampleTestimonials;
    const avatarColors = ['green', 'yellow', 'blue', 'cyan', 'orange', 'teal'];

    return (
        <div className="testimonials-page">
            <div className="testimonials-header">
                <div className="container">
                    <div className="header-line"></div>
                    <h1>Testimonials</h1>
                    <p>Discover real customer reviews and experiences with Swastik Packers and Movers. Our testimonials reflect our commitment to safe packing, timely delivery, professional relocation services, and customer satisfaction across local and interstate moves.</p>
                </div>
            </div>

            <section className="testimonials-content">
                <div className="container">
                    <span className="testimonial-badge">Testimonial</span>
                    <h2>What Our <span>Customers Say</span></h2>
                    <p className="testimonials-subtitle">Don't just take our word for it. Here's what our satisfied customers have to say about their moving experience with Swastik Packers and Movers.</p>
                    <div className="underline"></div>

                    <div className="testimonials-cards-grid">
                        {displayTestimonials.map((testimonial, index) => (
                            <div key={testimonial.id} className="testimonial-detail-card">
                                <div className="stars-large">
                                    {[...Array(testimonial.rating)].map((_, i) => (
                                        <FaStar key={i} />
                                    ))}
                                </div>
                                <p className="review-text">{testimonial.review_text}</p>
                                <div className="customer-detail">
                                    <div className={`customer-avatar avatar-${avatarColors[index % 6]}`}>
                                        {testimonial.customer_name.charAt(0)}
                                    </div>
                                    <div className="customer-info-text">
                                        <h3>{testimonial.customer_name}</h3>
                                        <span>{testimonial.location}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Testimonials;
